import React from 'react';
import { Modal } from 'app/components';
import { CaretLeft } from '@phosphor-icons/react';
import './style.scss';

const EditCancelModal = ({ onCancel, onConfirm, isOpen, handleBackEdit }) => {
  return (
    <div>
      <Modal
        isOpen={isOpen}
        size={'regular'}
        primaryText="Confirm"
        secondaryText="Cancel"
        title={<div className='bg-grey-10 p-2 rounded-full'><CaretLeft size={16} 
          onClick={handleBackEdit}/></div>}
        children=<div className="heading-24">
          Are you sure you want to discard the changes made?{' '}
        </div>
        onClickPrimaryCta={onConfirm}
        onClickSecondaryCta={onCancel}
        className='edit-cancel-modal'
      />
    </div>
  );
};

export default EditCancelModal;
